export default {
    cancel: 'Cancelar',
    changePassword: 'Alterar a senha',
    rotatePassword: 'Pelas políticas de segurança a senha deve ser alterada',
    confirmNewPasswordLabel: 'Confirme a nova senha',
    newPassword: 'Nova Senha',
    newPasswordLabel: 'Insira a nova senha',
    currentPassword: 'Senha atual',
    passwordMinLength: 'Pelo menos {n} caracteres',
    passwordLowerCase: 'Pelo menos 1 letra minúscula',
    passwordUpperCase: 'Pelo menos 1 maiúscula',
    specialCharacter: 'Pelo menos 1 caractere especial {n}',
    number: 'Pelo menos 1 número',
    updateSuccess: 'A senha foi atualizada',
}